import { FTTHServiceabilityAction } from '../actions/FTTHServiceabilityAction'
import { SequenceManagerAction } from '../actions/SequenceManagerAction'

const initState = {
    requestBody: {
        sectionId: "FTTHServiceability",
        steps: [
            {
                sequence: "0",
                stepId: "Serviceability",
                fields: [
                    {
                        name: "serviceability Response",
                        value: ""
                    },
                    {
                        name: "Delivery Address",
                        value: ""
                    },
                    {
                        name: "City",
                        value: ""
                    },
                    {
                        name: "Delivery Notes",
                        value: ""
                    },
                    {
                        name: "ODB ID",
                        value: ""
                    },
                    {
                        name: "ODB Provider",
                        value: ""
                    }
                ]
            }
        ]
    },
    allOdbsResponse: {},
    mapLocation: {}
}

const FTTHServiceabilityReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var FTTHServiceabilityValue = { ...state.requestBody.steps };

    switch (type) {

        case FTTHServiceabilityAction.FTTH_UPDATE_MAP_LOCATION:
            return { ...state, mapLocation: payload };

        case FTTHServiceabilityAction.FTTH_GET_MAIN_AND_AROUND_ODBS:
            return { ...state, allOdbsResponse: payload };

        case FTTHServiceabilityAction.FTTH_CLEAR_ODBS:
            return { ...state, allOdbsResponse: {}};

        case FTTHServiceabilityAction.FTTH_SERVICEABILITY_UPDATE:
            FTTHServiceabilityValue[0].fields[0].value = "";
            FTTHServiceabilityValue[0].fields[1].value = payload.address;
            FTTHServiceabilityValue[0].fields[2].value = payload.cityName;
            FTTHServiceabilityValue[0].fields[3].value = payload.notes;
            FTTHServiceabilityValue[0].fields[4].value = payload.odb;
            FTTHServiceabilityValue[0].fields[5].value = payload.provider;

            return state;

        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'FTTHServiceability')
            });
            if (section.length > 0) {
                for (let i = 0; i < FTTHServiceabilityValue[0].fields.length; i++) {
                    const checkoutField = section[0].steps[0].fields.filter((field: any) => { return (field.name === FTTHServiceabilityValue[0].fields[i].name) })[0];
                    FTTHServiceabilityValue[0].fields[i].value = checkoutField ? checkoutField.value : "";
                }
            }
            return state;

        default:
            return state;
    }

}

export default FTTHServiceabilityReducer;